module.exports = __webpack_public_path__ + "img/draw2_img1.992f88a9.png";